import { Platform } from 'react-native';

export const parseAnimationProps = (props: any) => {
  if (Platform.OS === 'web') return props;

  return { style: props };
};
